import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

export const WORKSPACE_SWITCH_LOCK_MESSAGE = '创建或编辑工作流时不可切换个人/团队模式';

const WorkspaceSwitchLockContext = createContext({
  locked: false,
  acquireLock: () => () => {},
});

export function WorkspaceSwitchLockProvider({ children }) {
  const [lockCount, setLockCount] = useState(0);

  const acquireLock = useCallback(() => {
    setLockCount((count) => count + 1);
    return () => {
      setLockCount((count) => Math.max(0, count - 1));
    };
  }, []);

  const value = useMemo(
    () => ({
      locked: lockCount > 0,
      acquireLock,
    }),
    [lockCount, acquireLock],
  );

  return (
    <WorkspaceSwitchLockContext.Provider value={value}>
      {children}
    </WorkspaceSwitchLockContext.Provider>
  );
}

export function useWorkspaceSwitchLocked() {
  return useContext(WorkspaceSwitchLockContext).locked;
}

/** 在 active 为 true 期间锁定顶栏个人/团队模式切换 */
export function useWorkspaceSwitchLock(active = true) {
  const { acquireLock } = useContext(WorkspaceSwitchLockContext);

  useEffect(() => {
    if (!active) return undefined;
    return acquireLock();
  }, [active, acquireLock]);
}
